/**
 * Gives the page's h2s the ids the "On this page" list already points at, then reveals it.
 *
 * PROGRESSIVE, AND HIDDEN UNTIL IT WORKS. blocks/page-content.liquid renders the merchant's
 * rich text untouched, so nothing in it carries an id. The list is written by Liquid, in
 * document order, and this only supplies the targets. If the script does not run, the nav
 * stays hidden rather than offering links that jump nowhere.
 *
 * ORDER IS THE CONTRACT, AND IT IS SOURCE ORDER. The nth link points at the nth h2 as it
 * appears in page.content, whether or not Liquid chose to link it. Neither side filters, so
 * neither side has to agree with the other about what counts as an empty heading -- and they
 * did not: `<h2>&nbsp;</h2>` is not blank to Liquid's `strip` and IS empty to `trim()`, which
 * treats U+00A0 as whitespace. A heading nobody links to simply carries an id nobody uses.
 *
 * FOCUS. A jump link moves the viewport but not, by default, the keyboard. tabindex="-1" on the
 * target makes the heading focusable so the next Tab continues from the section the reader
 * asked for, which is the same thing snippets/collection-index-group.liquid does for the same
 * reason.
 */
const nav = document.querySelector('[data-page-contents]');

if (nav) {
  const content = document.querySelector('.page-content');
  const headings = content ? [...content.querySelectorAll('h2')] : [];

  if (headings.length > 0) {
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `gv-page-heading-${index}`;
      heading.tabIndex = -1;
    });

    // A link with no heading behind it is worse than no link: it looks live and does nothing.
    for (const link of nav.querySelectorAll('a[href^="#gv-page-heading-"]')) {
      if (!document.getElementById(link.getAttribute('href').slice(1))) {
        link.closest('li')?.remove();
      }
    }

    if (nav.querySelector('a')) nav.hidden = false;
  }
}
